<template>
  <div class="navigator-drawer-action-icons">
    <nuxt-link :to="getBestsellerUrl">
      <div class="blue-pastel">
        <base-icon size="45px" class="white--text" mdi="bestseller"></base-icon>
      </div>
      <span class="text-body-5">{{ $t('commons.bestseller') }}</span>
    </nuxt-link>
    <nuxt-link :to="getHandmadeUrl">
      <div class="apricot-pastel">
        <base-icon size="45px" class="white--text" mdi="handmade"></base-icon>
      </div>
      <span class="text-body-5">{{ $t('commons.handMade') }}</span>
    </nuxt-link>
    <nuxt-link :to="getBioUrl">
      <div class="green-pastel">
        <base-icon size="45px" class="white--text" mdi="bio"></base-icon>
      </div>
      <span class="text-body-5">{{ $t('commons.bio') }}</span>
    </nuxt-link>
    <nuxt-link :to="getGiftIdea">
      <div class="rose-pastel">
        <base-icon size="45px" class="white--text" mdi="gift-idea"></base-icon>
      </div>
      <span class="text-body-5">{{ $t('commons.giftIdea') }}</span>
    </nuxt-link>
  </div>
</template>

<script>
import BaseIcon from '~/components/base/icon/BaseIcon'
import { getCategoryCustomField, getCategoryUrl } from '~/helpers'
import { ATTRIBUTE_CATEGORY_TECHNICAL_NAME } from '~/services/cfAttributes'

export default {
  name: 'NavigatorDrawerActionIcons',
  components: { BaseIcon },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getBestsellerUrl() {
      return this.getTechnicalUrl('bestseller')
    },
    getBioUrl() {
      return this.getTechnicalUrl('bio')
    },
    getHandmadeUrl() {
      return this.getTechnicalUrl('handmade')
    },
    getGiftIdea() {
      return this.getTechnicalUrl('gift-idea')
    },
  },
  methods: {
    getTechnicalUrl(technicalName) {
      return this.localePath(getCategoryUrl(this.findRoute(technicalName)))
    },
    findRoute(technicalName) {
      return this.categories.find((category) => {
        return (
          getCategoryCustomField(
            category,
            ATTRIBUTE_CATEGORY_TECHNICAL_NAME
          ) === technicalName
        )
      })
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.navigator-drawer-action-icons {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background: map-get($shades, 'grey-lighten-4');

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      width: 50px;
      border-radius: 50%;
      background: map-get($shades, 'blue-pastel');
    }

    > span {
      margin-top: 8px;
      color: map-get($shades, 'grey-darken-4');
      text-decoration: none;
    }
  }
}
</style>
